import { Card, InfoRow } from './BmsCardPrimitives'

const CapacityCard = ({ bms, className = '' }) => (
  <Card className={className}>
    <InfoRow label="Ah gained" value={bms.ahGained} />
    <InfoRow label="Ah spent" value={bms.ahSpent} />
    <InfoRow label="kWh spent" value={bms.whSpent} />
    <InfoRow label="Full capacity" value={bms.fullCapacity} />
    <InfoRow label="Remaining cap" value={bms.remainingCap} />
  </Card>
)

export default CapacityCard
